// 根域名机构 (C) 的配置来自 wenkoo-portal/functionConfig 接口,
// 字段与 tenant/queryUsableById 不完全一致: 完整图片地址在 *Path 字段, *Url 为相对路径,
// 且没有 name / dialogueExampleDetailVO / expiredFlag。这里归一化成模板使用的 IData 形状。
import type { IData } from '@/types';
import { ROOT_DOMAIN } from './resolveTenantId';

interface FunctionConfig {
  id: string;
  enableModuleList?: number[];
  agentTypeList?: string[];
  modelList?: number[];
  homeLogoUrl?: string;
  homeLogoPath?: string;
  loginLogoUrl?: string;
  loginLogoPath?: string;
  agentBackgroundUrl?: string;
  agentBackgroundPath?: string;
}

export function normalizeFunctionConfig(config: FunctionConfig): IData {
  return {
    ...config,
    logoUrl: config.homeLogoPath || config.homeLogoUrl,
    homeLogoUrl: config.homeLogoPath || config.homeLogoUrl,
    loginLogoUrl: config.loginLogoPath || config.loginLogoUrl,
    agentBackgroundUrl: config.agentBackgroundPath || config.agentBackgroundUrl,
    expiredFlag: false,
    activateCodeFlag: false,
  } as IData;
}

export async function fetchRootTenantConfig(tenantId: string): Promise<IData | null> {
  const url = `https://${ROOT_DOMAIN}/wk-api/wenkoo-portal/functionConfig/getFunctionConfig?id=${tenantId}`;
  const response = await fetch(url, { headers: { 'tenant-id': tenantId } });
  const res = await response.json();
  if (res.code === 0 && res.data) {
    return normalizeFunctionConfig(res.data);
  }
  return null;
}
